import React, { ChangeEvent, Dispatch, FC, SetStateAction } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import paypalIcon from 'assets/img/icons/Paypal.svg';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import visaCardIcon from 'assets/img/creditCardsIcons/visa.png';
import masterCardIcon from 'assets/img/creditCardsIcons/mastercard.png';
import amexCardIcon from 'assets/img/creditCardsIcons/americanexpress.png';
import { useTheme } from '@material-ui/core';
import useIsUserLoggedIn from '../../../../config/hooks/useIsUserLoggedIn';
import { parsePriceByCurrency } from '../../../../config/utils/currencyUtils';
import { CurrentUserReducer, RootReducer } from '../../../../models/Redux';
import { Currency } from '../../../../models/Currency';

interface Props {
    savedCard: { status: boolean; stripe_payment_method_id?: number };
    setSavedCard: Dispatch<SetStateAction<{ status: boolean; stripe_payment_method_id?: number }>>;
    currency: Currency;
    paypal: boolean;
    setUsesPaypal: Dispatch<SetStateAction<boolean>>;
    email: string;
    setEmail: Dispatch<SetStateAction<string>>;
    confirmEmail: string;
    setConfirmEmail: Dispatch<SetStateAction<string>>;
    privacy: boolean;
    setPrivacy: Dispatch<SetStateAction<boolean>>;
    terms: boolean;
    setTerms: Dispatch<SetStateAction<boolean>>;
    finalPrice: string | undefined;
    payment: { status?: string; message?: string };
    handlePurchase: () => Promise<void>;
}

const Checkout: FC<Props> = ({
    savedCard,
    setSavedCard,
    currency,
    paypal,
    setUsesPaypal,
    handlePurchase,
    email,
    setEmail,
    confirmEmail,
    setConfirmEmail,
    payment,
    privacy,
    setPrivacy,
    terms,
    setTerms,
    finalPrice,
}) => {
    const theme = useTheme();
    const isUserLoggedIn = useIsUserLoggedIn();

    const { userCardMethods: userCards } = useSelector<RootReducer, CurrentUserReducer>(
        state => state.currentUser,
    );

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.name === 'privacy') {
            setPrivacy(!privacy);
        } else if (e.target.name === 'terms') {
            setTerms(!terms);
        }
    };
    const handlePaymentMethodClick = (e: ChangeEvent<HTMLInputElement>) => {
        const { target } = e;

        if (target.id === 'paypal') {
            setUsesPaypal(true);
            setSavedCard({ status: false });
        }
        if (target.id === 'card') {
            setUsesPaypal(false);
            setSavedCard({ status: false });
        }
        if (target.id === 'savedCard') {
            setUsesPaypal(false);

            setSavedCard({ status: true, stripe_payment_method_id: userCards[0].id });
        }
    };

    return (
        <>
            {parseFloat(finalPrice || '0') > 0 && (
                <div className="">
                    <div
                        className="mb-3"
                        style={{ borderBottom: '1px solid #F4F2F2', paddingBottom: '8px', display: 'flex' }}
                    >
                        <div style={{ width: '90%' }} className="w-100">
                            <CardElement
                                options={{
                                    style: {
                                        base: {
                                            // @ts-ignore
                                            width: '100%',
                                            fontSize: '17px',
                                            color: theme.palette.secondary.main,
                                            '::placeholder': {
                                                color: theme.palette.secondary.light,
                                            },
                                        },
                                    },
                                    hidePostalCode: true,
                                }}
                            />
                        </div>
                        <input
                            id="card"
                            checked={!paypal && (!savedCard || !savedCard.status)}
                            type="radio"
                            name="payment"
                            className="Radio-redonda"
                            onChange={handlePaymentMethodClick}
                        />
                    </div>
                </div>
            )}

            {parseFloat(finalPrice || '0') > 0 && userCards && userCards.length > 0 && (
                <div>
                    <div
                        className="mb-3"
                        style={{ borderBottom: '1px solid #F4F2F2', paddingBottom: '8px', display: 'flex' }}
                    >
                        <div style={{ width: '90%' }} className="w-100">
                            <span>
                                <img
                                    alt="card"
                                    style={{ width: 30, height: 30, marginRight: 12 }}
                                    src={
                                        userCards[0] && userCards[0].card.brand === 'visa'
                                            ? visaCardIcon
                                            : userCards[0].card.brand === 'mastercard'
                                            ? masterCardIcon
                                            : userCards[0].card.brand === 'amex'
                                            ? amexCardIcon
                                            : visaCardIcon
                                    }
                                />{' '}
                            </span>
                            <span
                                style={{ color: savedCard.status ? 'black' : 'rgb(179, 184, 193)' }}
                                className="mr-2 tw-text-2xl"
                            >
                                {' '}
                                ************
                            </span>
                            <span style={{ color: savedCard.status ? 'black' : 'rgb(179, 184, 193)' }}>
                                {userCards[0] && userCards[0].card.last4}
                            </span>
                        </div>
                        <input
                            id="savedCard"
                            checked={savedCard && savedCard.status}
                            type="radio"
                            name="payment"
                            className="Radio-redonda"
                            onChange={handlePaymentMethodClick}
                        />
                    </div>
                </div>
            )}
            {parseFloat(finalPrice || '0') > 0 && (
                <div className="d-flex align-items-center mb-3 Input-linea">
                    <img src={paypalIcon} alt="" />
                    <div className="d-flex flex-column ml-3 w-100">
                        <label
                            style={{
                                color: paypal ? theme.palette.secondary.main : theme.palette.secondary.light,
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            Paypal
                        </label>
                    </div>
                    <input
                        id="paypal"
                        type="radio"
                        checked={paypal}
                        name="payment"
                        className="Radio-redonda"
                        onChange={handlePaymentMethodClick}
                    />
                </div>
            )}
            {!isUserLoggedIn && (
                <div className="mb-2">
                    <input
                        required
                        type="email"
                        className="emailInput mb-2"
                        name="email"
                        placeholder={i18next.t('CheckoutComponentEnterEmailAddress')}
                        value={email}
                        onChange={e => setEmail(e.target.value.toLowerCase())}
                    />
                    <input
                        required
                        type="email"
                        className="emailInput mb-2"
                        name="confirmEmail"
                        placeholder={i18next.t('CheckoutComponentConfirmEmailAddress')}
                        value={confirmEmail}
                        onChange={e => setConfirmEmail(e.target.value.toLowerCase())}
                    />
                </div>
            )}

            {!isUserLoggedIn && (
                <>
                    <div style={{ paddingLeft: '16px' }} className="form-check">
                        <label className="form-check-label" htmlFor="privacy">
                            <input
                                style={{ display: 'block' }}
                                type="checkbox"
                                className="form-check-input"
                                id="privacy"
                                name="privacy"
                                onChange={handleInputChange}
                                checked={privacy}
                            />
                            {i18next.t('CheckoutComponentIAgreeWithThe')}{' '}
                            <Link to="/terms/privacy">{i18next.t('CheckoutComponentPrivacyPolicy')}</Link>
                        </label>
                    </div>
                    <div style={{ paddingLeft: '16px' }} className="form-check">
                        <label className="form-check-label" htmlFor="terms">
                            <input
                                style={{ display: 'block' }}
                                type="checkbox"
                                className="form-check-input"
                                id="terms"
                                name="terms"
                                onChange={handleInputChange}
                                checked={terms}
                            />
                            {i18next.t('CheckoutComponentIAgreeWithThe')}{' '}
                            <Link to="/terms/service">{i18next.t('CheckoutComponentTermsOfService')}</Link>
                        </label>
                    </div>
                </>
            )}
            {parseFloat(finalPrice || '0') > 0 && !paypal && (
                <span className="my-2" style={{ fontSize: '13px' }}>
                    * {i18next.t('CheckoutComponentCardPaymentsAreProcessedByStripeDescription')}
                </span>
            )}
            <div style={{ position: 'relative' }}>
                {payment.status !== 'loading' ? (
                    <button
                        type="button"
                        style={{ position: 'relative', top: '0px' }}
                        data-toggle="modal"
                        data-dismiss="modal"
                        data-target="#myModal2"
                        className="Btn-rojo-b mt-4"
                        onClick={handlePurchase}
                    >
                        {parseFloat(finalPrice || '0') > 0 ? (
                            <span>
                                {' '}
                                {i18next.t('CheckoutComponentPay')}{' '}
                                {parsePriceByCurrency(finalPrice, currency)}{' '}
                            </span>
                        ) : (
                            <span> {i18next.t('CheckoutComponentBuyTicketForFree')}</span>
                        )}
                    </button>
                ) : (
                    <button
                        type="button"
                        disabled
                        style={{ position: 'relative', top: '0px' }}
                        data-toggle="modal"
                        data-dismiss="modal"
                        data-target="#myModal2"
                        className="Btn-rojo-b mt-4"
                    >
                        {i18next.t('CheckoutComponentProcessingYourPayment')}...
                    </button>
                )}
            </div>
        </>
    );
};

export default Checkout;
